// requiredFields — the ordered list of required form fields for ManualTripCreator.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (the module-level
// `REQUIRED_FIELDS` array) as part of the behavior-preserving refactor (issue
// #240). The ORDER of this list is observable: `validateForm` walks it top to
// bottom and returns the FIRST blank field's message, so the source's
// validation precedence (tripName → startDate → startDestination → endDate →
// endDestination) is encoded entirely by this ordering. Each entry's `message`
// and `trim` flag are copied exactly from the source.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * The ordered required-field descriptors for the manual trip form.
 *
 * @type {Array<{ key: string, message: string, trim: boolean }>}
 */
export const REQUIRED_FIELDS = [
  { key: 'tripName', message: 'Trip name is required', trim: true },
  { key: 'startDate', message: 'Start date is required', trim: false },
  { key: 'startDestination', message: 'Start destination is required', trim: true },
  { key: 'endDate', message: 'End date is required', trim: false },
  { key: 'endDestination', message: 'End destination is required', trim: true },
];

export default REQUIRED_FIELDS;
